<template>
  <NuxtLoadingIndicator :throttle="0" color="#751D2A" />
  <div class="page grid grid-rows-[auto_1fr_auto]">
    <Header class="z-10" />
    <NuxtPage />
    <Footer />
  </div>
</template>
